import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Toaster } from "./components/toast";
/**
 * Wrap Primary UI apps in this to ensure any dependencies, like our Toaster + sonner, are loaded at the right time.
 * And, because consumers shouldn't have to know about internal dependencies "sonner".
 * In the future, this could also handle things like theming (e.g. changing CSS variables in JS)
 */
export function PrimaryUIProvider({ children }) {
    return (_jsxs(_Fragment, { children: [_jsx(Toaster, {}), children] }));
}
